import React, { useEffect } from 'react';

import { WoocommerceModal } from './woocommerce-modal';
import { toCancellable } from '../../../shared/axios';
import { useWoocommerce } from './woocommerce.hooks';

export const Woocommerce = () => {
    const {
        loading,
        integrationData,
        loadInitialData,
        submitting,
        save,
    } = useWoocommerce();

    useEffect(() => toCancellable(loadInitialData()), [loadInitialData]);

    return (
        <WoocommerceModal
            onSubmit={save}
            initialData={integrationData}
            isSubmitting={submitting}
            isLoading={loading}
        />
    );
};
